export const backupTopics: string[] = [
    "Backup Seguro",
    "Recuperación de Datos",
    "Protección de Archivos",
    "Disaster Recovery",
    "Backup Incremental",
    "Respaldo Automático",
    "Copia de Seguridad en la Nube",
    "Seguridad de la Información",
    "Cifrado de Datos",
    "Backup Offsite",
    "Recuperación Ante Desastres",
    "Almacenamiento de Respaldo",
    "Redundancia de Datos",
    "Snapshot Storage",
    "Backup para Empresas",
    "Protección contra Ransomware",
    "Seguridad en Centros de Datos"
  ];
  